var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5691 3.74781C33.1749 2.27276 32.013 1.11086 30.5379 0.716571C27.8644 -1.81652e-07 17.1429 0 17.1429 0C17.1429 0 6.42133 -1.81652e-07 3.74781 0.716571C2.27276 1.11086 1.11086 2.27276 0.716571 3.74781C0 6.42133 0 12 0 12C0 12 0 17.5787 0.716571 20.2522C1.11086 21.7272 2.27276 22.8891 3.74781 23.2834C6.42133 24 17.1429 24 17.1429 24C17.1429 24 27.8644 24 30.5379 23.2834C32.013 22.8891 33.1749 21.7272 33.5691 20.2522C34.2857 17.5787 34.2857 12 34.2857 12C34.2857 12 34.2857 6.42133 33.5691 3.74781ZM13.7143 17.1429V6.85714L22.6217 12L13.7143 17.1429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/Youtube_Icon.8ccd98c813f05cac8baf8e86a7527087.svg";
export { ForwardRef as ReactComponent };